import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import localeEN from './locales/en-US.js'
import localeTH from './locales/th-TH.js'

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places'
  },
  installComponents: true
})

import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)

import SlimSelect from 'slim-select'
import 'slim-select/dist/slimselect.min.css'
Vue.use({
  install(Vue) {
    Vue.prototype.$slimSelect = SlimSelect
  }
})
import draggable from 'vuedraggable'
Vue.component('draggable',draggable)

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import App from './App.vue'
import router from './router'

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import './parse'

import './assets/css/main.scss'

Vue.config.productionTip = false

//start import all components from @/components
const requireComponent = require.context(
  // The relative path of the components folder
  './components',
  // Whether or not to look in subfolders
  true,
  // The regular expression used to match base component filenames
  /\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Strip the leading `./` and extension from the filename
      fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
    )
  )
  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})

const i18n = new VueI18n({
  locale: 'th',
  messages: {
    en: localeEN,
    th: localeTH
  }
})

new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
